
export const styleSheet = () => ({
  closableMenu:{
  
    }
  })